import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import { BrandSelector } from '~/components/features/BrandSelector'
import { useFormField } from '~/hooks/useFormField'
import { findByPath } from '~/utils'

import {
  type SurveyGroupSurvey,
  useMainQuerySurveys,
} from '../../hooks/useMainQuery'

import { type InputValues } from './utils'

export type AttachedBrandSelectorProps = {
  index: number
  survey: SurveyGroupSurvey
}

export const AttachedBrandSelector = ({
  index,
  survey,
}: AttachedBrandSelectorProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const field = useFormField(
    control,
    `brands.${index}.attachedBrandMap.${survey.id}`,
  )

  const surveys = useMainQuerySurveys()
  const brands = React.useMemo(
    () =>
      R.pipe(
        surveys,
        findByPath('id', survey.id),
        (survey) => survey?.brandGroups ?? [],
        R.flatMap(R.prop('brands')),
      ),
    [survey.id, surveys],
  )

  return (
    <LabelingContainer label={survey.title} labelVariant="small">
      <BrandSelector
        brands={brands}
        isNullSelectable={true}
        nullText={t('no_corresponding_brand')}
        {...field}
      />
    </LabelingContainer>
  )
}
